<template>
  <section class="hello">
      <b-img alt="HME Rotary" fluid src="../assets/hme-logo--web.png"/>

    <h1 class="mb-0">The UK's longest established<br><strong class="text-secondary">Rotary Engine Specialists</strong></h1>
    <p class="text-uppercase mt-2 fs-5">
      Welcome to <span class="text-secondary">HME Rotary</span>
    </p>
  </section>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<style scoped>
  .fs-5{
    font-size: 1.5em
  }
</style>
